import type { FooterColumnsProps } from './footer.types'

import { useDown, vui } from '../core'
import FooterColumn from './footerColumn'
import FooterRow from './footerRow'

/** Organizes sections with links into a single column. Different width per breakpoint. */
const FooterColumns = vui<'div', FooterColumnsProps>((props, ref) => {
  const { columns } = props
  const downMd = useDown('md')

  if (!columns) return null
  if (downMd) {
    const columnsEven = columns.filter((_, index) => index % 2 === 0).flat()
    const columnsOdd = columns.filter((_, index) => index % 2 === 1).flat()
    return (
      <FooterRow ref={ref}>
        <FooterColumn key={'evenColumns'} sections={columnsEven} />
        <FooterColumn key={'oddColumns'} sections={columnsOdd} />
      </FooterRow>
    )
  }
  return (
    <FooterRow ref={ref}>
      {columns.map((sections, index) => (
        <FooterColumn key={index} sections={sections} />
      ))}
    </FooterRow>
  )
})

FooterColumns.displayName = 'Footer Mobile Column'
export default FooterColumns
